import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { httpJSON } from '../../../shared/api/http';

export function useIbConfigQuery() {
  return useQuery({
    queryKey: ['ib', 'config'],
    queryFn: () => httpJSON('/ib/config'),
  });
}

export function useIbkrCommModeQuery() {
  return useQuery({
    queryKey: ['diag', 'ibkrCommMode'],
    queryFn: () => httpJSON('/v1/diag/ibkr-comm-mode'),
    staleTime: 0,
  });
}

export function useSetIbkrCommModeMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (mode) =>
      httpJSON('/v1/diag/ibkr-comm-mode', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mode }),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['diag', 'ibkrCommMode'] });
      qc.invalidateQueries({ queryKey: ['livePrices'] });
    },
  });
}

export function useIbStatusQuery() {
  return useQuery({
    queryKey: ['ib', 'status', 'global'], // invalidated on-demand
    queryFn: () => httpJSON('/ib/status'),
  });
}

export function useTestMktdataMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (symbol) => httpJSON('/ib/test_mktdata', {}, { symbol }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['ib', 'status'] });
      qc.invalidateQueries({ queryKey: ['ib', 'status', 'global'] });
    },
  });
}
